export default __webpack_public_path__ + "static/media/hht2_ep8_speaking_01.dcd00210.png";